// Вопрос узла решений о виде упоминания (005-3: FR-002, FR-004, FR-017; research, Р1; ADR-0027).
// Вход — только текст одного упоминания (без подсказки в скобках) и название колонки: по поправке
// IV 1.13.0 он не маскируется — вид нельзя спросить по метке. Инструкция вопроса — у узла
// (recognition/kind.ts); версия растёт при любой правке инструкции или полей входа.
import { z } from '../kernel/zod.ts';
import type { MentionColumn } from '../directory/mention.ts';

export const MENTION_KIND_QUESTION_ID = 'mention_kind';
export const MENTION_KIND_QUESTION_VERSION = 'v2';

/** Название колонки во входе модели — как в шапке листа. */
export const mentionKindColumnNames = {
  responsible: 'Ответственный',
  contractor: 'Подрядчик',
} as const satisfies Record<MentionColumn, string>;

/** Вход вопроса: больше полей нет (FR-002). */
export const MentionKindInputSchema = z.strictObject({
  упоминание: z.string().min(1),
  колонка: z.enum(['Ответственный', 'Подрядчик']),
});
export type MentionKindInput = z.infer<typeof MentionKindInputSchema>;

/** Граница подсказки «скорее организация / скорее человек» (FR-006): не настройка. */
export const KIND_HINT_BOUNDARY = 0.5;
